import React from 'react';
import BiomePieChart from './BiomePieChart';
import { useTheme } from '../theme/ThemeContext';
import Button from './widgets/button';
import downloadImageWhite from '../static/images/download_icon_white.png';
import downloadImageBlack from '../static/images/download_icon_black.png';



const BiomeTree = ({ multipleSamplesMetaData, possibleColorDict, scatterplot, colors, colorDict, ids, currentPointsSelection, totalBiomeCounts }) => {
    const { theme } = useTheme();

    const downloadImage = theme.name === 'light' ? downloadImageBlack : downloadImageWhite;

    const getBiomeCounts = (data) => {
        if (!data) return {};

        const biomeCounts = {};

        data.forEach(sample => {
            const biome = sample.meta_data.source_biome.replace(/root:/g, '').trim();
            if (biomeCounts[biome]) {
                biomeCounts[biome]++;
            } else {
                biomeCounts[biome] = 1;
            }
        });

        return biomeCounts;
    };

    const getAvgShannonIndex = (data) => {
        if (!data || data.length === 0) return 0;

        const validShannonIndices = data
            .map(sample => parseFloat(sample.meta_data.shannon_index_10))
            .filter(index => index !== null && index !== undefined && !isNaN(index));

        if (validShannonIndices.length === 0) return 0;

        const sum = validShannonIndices.reduce((acc, index) => acc + index, 0);
        return sum / validShannonIndices.length;
    }

    const downloadBiomeCounts = () => {
        if (!multipleSamplesMetaData || multipleSamplesMetaData.length === 0) return;

        const biomeCounts = getBiomeCounts(multipleSamplesMetaData);

        // Sort by count (descending)
        const sortedBiomes = Object.entries(biomeCounts)
            .sort((a, b) => b[1] - a[1]);

        const header = 'Biome,Selected Count,Total Count\n';
        const csvContent = sortedBiomes.reduce((acc, [biome, count]) => {
            const prettyBiome = biome.replace(/:/g, ' ').replace(/_/g, ' ');
            const biomeName = prettyBiome.includes(',') ? `"${prettyBiome}"` : prettyBiome;
            const totalCount = totalBiomeCounts[biome] || count;
            return acc + `${biomeName},${count},${totalCount}\n`;
        }, header);

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'biome_sample_counts.csv';

        document.body.appendChild(a);
        a.click();

        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    // const avgShannonIndex = getAvgShannonIndex(multipleSamplesMetaData)
    // console.log(avgShannonIndex);


    const biomeCounts = getBiomeCounts(multipleSamplesMetaData);

    const topBiomes = Object.entries(biomeCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5);


    return (
        <div style={{ fontFamily: 'monospace' }}>

            <BiomePieChart
                multipleSamplesMetaData={multipleSamplesMetaData}
                possibleColorDict={possibleColorDict}
                scatterplot={scatterplot}
                colors={colors}
                colorDict={colorDict}
                ids={ids}
                currentPointsSelection={currentPointsSelection}
            />

            <div>
                <p style={{ fontSize: '22px' }}>Top 5 Biomes:</p>
                <ul>
                    {topBiomes.map(([biome, count]) => {
                        const colorKey = `root:${biome}`;
                        // console.log("colorKey:", colorKey);

                        const prettyBiome = biome.replace(/:/g, ' ').replace(/_/g, ' ');

                        const color = possibleColorDict[colorKey];
                        const totalCount = totalBiomeCounts[biome] || count;

                        const colorStyle = color
                            ? `rgb(${color[0]}, ${color[1]}, ${color[2]})`
                            : 'black';

                        return (
                            <li
                                key={biome}
                                style={{ color: theme.colors.text, display: 'flex', alignItems: 'center', marginBottom: '8px', fontSize: '22px', fontFamily: 'Arial' }}
                            >
                                <span
                                    style={{
                                        width: '1rem',
                                        height: '1rem',
                                        backgroundColor: colorStyle,
                                        display: 'inline-block',
                                        // marginRight: '8px',
                                        marginRight: '20px',
                                        border: '1px solid #ccc',
                                        flexShrink: 0,
                                    }}
                                ></span>
                                {/* {prettyBiome} ({count} samples) */}
                                {prettyBiome} ({count}/{totalCount} samples)
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Button onClick={downloadBiomeCounts}>
                    CSV
                    <img src={downloadImage} alt="download CSV" style={{ marginLeft: '8px', height: '1em' }} />
                </Button>
            </div>
        </div>
    );
};

export default BiomeTree;